import baseApi, { TAGS } from '../api/baseApi';

const filesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFiles: builder.query({
      query: (userId) => ({
        url: `files`,
        params: {
          userId
        },
        method: 'GET'
      }),
      transformResponse: (response) => response.data,
      providesTags: [TAGS.FILES]
    }),
    uploadFile: builder.mutation({
      query: (file) => ({
        url: 'files',
        method: 'POST',
        body: file
      }),
      transformResponse: (response) => response.data
    })
  })
});

export const { useGetFilesQuery, useUploadFileMutation } = filesApi;
